import React, {FunctionComponent} from "react";

const styles = require('./moreArticles.module.scss');
import {WordpressPost} from "../../interfaces/wordpressPost.interface";
import {Article, BlogTitleLink} from "@klear/open-site";

interface MoreArticlesProps {
    mainTitle: string,
    sideTitle?: string,
    sectionIcon?: string,
    posts: Array<{ node: WordpressPost }>;
    isCategoryPage: boolean
    isLink?: boolean
}

export const MoreArticles: FunctionComponent<MoreArticlesProps> = ({sectionIcon, mainTitle, posts, isCategoryPage, sideTitle, isLink}) => {
    return (
        <>
            <div className={`${styles.container} ${isCategoryPage ? styles.categoryPageContainer : ''}`}>
                {/*Inner pages do not need title to be a link*/}
                {isLink ?
                    <BlogTitleLink mainTitle={mainTitle} sectionIcon={sectionIcon} sideTitle={sideTitle} sideTitleLink={posts[0].node.categories[0].slug}
                                   divider={true}/>
                    :
                    <BlogTitleLink mainTitle={mainTitle} sectionIcon={sectionIcon} sideTitle={sideTitle} divider={true}/>
                }
                <div className={`${styles.containerBottom} ${isCategoryPage ? styles.categoryPage : styles.mainPage} `}>
                    {posts.map(({node}) => (
                        <div className={styles.mainArticle}>
                            {isCategoryPage ?
                                <a href={`/blog/${node.slug}/`}>
                                    <Article mainArticleImage={node.featured_media?.source_url}
                                                 mainArticleTitle={node.title}
                                                 mainArticleDescription={node.excerpt}
                                                 isSmall={true} tag={node.categories[0].name}
                                    />
                                </a>
                                :
                                <a href={`${node.slug}/`}>
                                    <Article mainArticleImage={node.featured_media?.source_url}
                                                 mainArticleTitle={node.title}
                                                 mainArticleDescription={node.excerpt}
                                                 isSmall={true} tag={undefined}
                                    />
                                </a>
                            }
                            <div className={styles.gotToArticleCont}>
                                <div className={styles.gotToArticleSmall}>
                                    <div className={styles.goToIcon}>
                                        <i className='fa fa-arrow-right'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}
